import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-authenticate',
  standalone: false,
  templateUrl: './authenticate.page.html',
  styleUrl: './authenticate.page.css'
})
export class AuthenticatePage implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    const tokenType =
      this.route.snapshot.queryParamMap.get('stytch_token_type') || '';

    // If this is a password reset token, forward to the reset password page
    if (tokenType.toLowerCase().includes('password')) {
      this.router.navigate(['/auth/reset-password'], {
        queryParams: { token: token },
      });
      return;
    }

    const rawReturnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    const returnUrl = this.sanitizeReturnUrl(rawReturnUrl);
    const mfaQueryParams = returnUrl ? { returnUrl } : undefined;

    this.authService.authenticate(token ?? "")
      .then((response: any) => {
        const isEnrolled = !!(response.member?.totp_registration_id || response.member?.mfa_enrolled);
        const mfaRequired = !!(response.mfa_required || response.intermediate_session_token);

        if (!isEnrolled || mfaRequired) {
          this.router.navigate(['/auth/mfa'], { queryParams: mfaQueryParams });
        } else if (this.authService.isLoggedIn()) {
          this.router.navigateByUrl(returnUrl);
        } else {
          this.router.navigate(['/auth/mfa'], { queryParams: mfaQueryParams });
        }
      })
      .catch((err) => {
        console.error(err);
        alert(
          'Email Magic Link authentication failed. See console for details.'
        );
      });
  }

  private sanitizeReturnUrl(url: string | null): string {
    if (!url) return '/dashboard/home';
    if (url.startsWith('/dashboard')) {
      return url;
    }
    return '/dashboard/home';
  }
}
